
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["prt-icon prt-option-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.49 84.09"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.28 34.02H21.9v9.07h21.38zm0 46.16V51.61H21.9v28.57H9.28V34.02H0L49.75 0v80.18zm48.47 3.91H0v-1.7h91.75zm2.18-33.52v25.7h25.74V61.9zm28.56 29.61H93.92v-1.7h28.57zM84.35 20.24v-17H74.06v10.25z","fill":"#9b9c9e"}}),_c('path',{attrs:{"d":"M85.98 63.5H57.04v-9.07h28.94v9.07zm-7.56-20.41H57.04v-9.07h21.38zm22.61-9.07L51.26.02v80.16h40.49V34.02z","fill":"#b0b2b3"}}),_c('path',{staticClass:"prt-icon-color",attrs:{"d":"M23.31 53.03h18.55v27.16H23.31z"}})])
          )
        }
      }
    